var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"manufacture-devices"}},[_vm._v("Manufacturers")]),_vm._v(" "),_c('input',{staticClass:"tags-field",attrs:{"name":"tags-field","readonly":_vm.readonly,"id":"manufacture-devices","placeholder":"Type the manufacture devices used on the project..."}})])
}
var staticRenderFns = []

export { render, staticRenderFns }